import styled from '@emotion/styled';

const StyledDateField = styled('section')({
  marginBottom: -10,
});

export default StyledDateField;
